import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';

import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;

import ContentHeader from 'components/ContentHeader';
import Button from 'components/Button';
import Footer from 'components/AppFooter/AppFooter';
import Input from 'components/Input';
import Loader from 'components/Loader/Loader';
import { VisibleOnlyAdmin, VisibleOnlyCustomer } from 'components/AuthenticatedComponent';

import { keyedObjToArr } from '../../util';

import 'sass/components/ui-list';

class Account extends Component {

    constructor (props){
        super(props);

        this.state = {
            name : this.props.profile ? this.props.profile.name : ''
        };
    }

    updateName (event) {
        this.setState({
            name: event.target.value
        });

        const { firebase } = this.props;
        firebase.set(`/users/${this.props.profile.id}/name`, event.target.value)
    }



	handleLogout (event) {
		event.preventDefault();
		this.props.firebase.logout();
		browserHistory.replace("/");
	}

	//TODO Move logout to Content Header
	//Name
	//Customer
	//Role
	//Email / Password

	render () {

        if( !isLoaded(this.props.profile) ||
            !isLoaded(this.props.products) ||
            !isLoaded(this.props.customer) ||
            !isLoaded(this.props.classrooms) ||
            !isLoaded(this.props.schools) ||
            !isLoaded(this.props.users)
        ) {
            return (
                <div className="main-content-area">
                    <div className="page-content">
                        <Loader color="main" size="large" />
                    </div>
                    <Footer/>
                </div>
            );
        }

        let classrooms;
        let customer;
        let customers;
        let customerSchools;
        let products = [];

        let name = this.state.name !== '' ? this.state.name : this.props.profile.name;

        //Not admin and not customer
        if(!this.props.profile.customer && this.props.profile.role !== 'admin') {

            return(
                <div className="main-content-area">
                    <div className="page-content">
                        <div><h3>No Customer for User</h3></div>
                    </div>
                </div>
            );
            //Not admin and customer
        }
        else if(this.props.profile.customer && this.props.profile.role !== 'admin') {

            customer = this.props.customer;

            if(!customer.schools) {
                return this.renderSchoolInput();
            }

            customerSchools = keyedObjToArr(customer.schools).map( (school) => {
                if(!this.props.schools[school.id]) {
                    console.warn('couldnt find school with id ' + school.id);
                }
                return this.props.schools[school.id];
            });

            classrooms = customerSchools.reduce( (classrooms, school) => {
                if(school) {
                    keyedObjToArr(school.classrooms).forEach( (classroom) => {
                        if(this.props.classrooms[classroom.id]) {
                            let classroomObj = this.props.classrooms[classroom.id];
                            classroomObj.id = classroom.id;
                            if (classroomObj.teacher === this.props.profile.id) {
                                classrooms.push(classroomObj);
                            }
                        }
                    }, this);
                }

                return classrooms;
            }, []);

            let orderIds = Object.keys(customer.orders);

            if(orderIds && typeof(orderIds) === 'string') {
                orderIds = [orderIds];
            }

            if (orderIds) {
                orderIds.forEach( (orderId)=> {
                    let orderProducts = keyedObjToArr(this.props.orders[orderId].products);
                    products = products.concat(orderProducts);
                });
            }
        }
        // Admin
        else if(this.props.profile.role === 'admin') {
            classrooms = keyedObjToArr(this.props.classrooms);
            customers = keyedObjToArr(this.props.customer);
        }

        let button = (<Button
			label="Logout"
			onClick={this.handleLogout.bind(this)}
		/>);


		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
                transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area" key="account">
				<ContentHeader
					title="Account"
					button={button}
				/>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<div className="col-8 ui-list">
                                <div className="main-list-area">
                                    <div className="list-row">
                                        <div className="col-3 label list-cell">Name:</div>
                                        <div className="col-9 data list-cell">
                                            <Input
                                                placeholder="User Name"
                                                name="name"
                                                value={name}
                                                onChange={this.updateName.bind(this)}
                                            />
                                        </div>
                                    </div>
                                    <div className="list-row">
                                        <div className="col-3 label list-cell">Email:</div>
                                        <div className="col-9 data list-cell">{this.props.profile.email}</div>
                                    </div>
                                    {this.props.profile.role !== 'admin' && (
                                        <div>
                                            {/*District*/}
                                            <div className="list-row">
                                                <div className="col-3 label list-cell">District:</div>
                                                <div className="col-9 data list-cell">{customer.name}</div>
                                            </div>
                                            {/*Schools*/}
                                            <div className="list-row">
                                                <div className="col-3 label list-cell">{customerSchools.length > 1 ? ('Schools') : ('School')}</div>
                                                <div className="col-9 data list-cell">
                                                    <ul>
                                                        {customerSchools.map((school, index) => {
                                                            return (<li key={index}>{school.name}</li>);
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                            {/*Classrooms*/}
                                            <div className="list-row">
                                                <div className="col-3 label list-cell">{classrooms.length > 1 ? ('Classrooms') : ('Classroom')}</div>
                                                <div className="col-9 data list-cell">
                                                    <ul>
                                                        {classrooms.map((classroom, index) => {
                                                            return (<li key={index}>{classroom.name}</li>);
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                            {/*Products*/}
                                            <div className="list-row">
                                                <div className="col-3 label list-cell">{products.length > 1 ? ('Products') : ('Product')}</div>
                                                <div className="col-9 data list-cell">
                                                    <ul>
                                                        {products.map((product, index) => {
                                                            return (<li key={index}>{product.name}</li>);
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
						</div>
					</div>
					<Footer/>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}


const fbWrappedComponent = firebaseConnect( ({auth, profile}) => {

    if(!profile){
        return [];
    } else if (profile.customer) {
        return [
            {
                path: 'users',
                storeAs: 'users',
                queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
            },
            {
                path: 'customers/'+profile.customer,
                storeAs: 'customer'
            },
            {
                path: 'schools',
                storeAs: 'schools',
                queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
            },
            {
                path: 'orders',
                storeAs: 'orders',
                queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
            },
            {
                path: 'classrooms',
                storeAs: 'classrooms'
            },
            {
                path: 'products',
                storeAs: 'products'
            }
        ];;
    } else if (profile.role === 'admin'){
        return [
            {
                path: 'users',
                storeAs: 'users'
            },
            {
                path: 'customers',
                storeAs: 'customer'
            },
            {
                path: 'schools',
                storeAs: 'schools'
            },
            {
                path: 'orders',
                storeAs: 'orders'
            },
            {
                path: 'classrooms',
                storeAs: 'classrooms'
            },
            {
                path: 'products',
                storeAs: 'products'
            }
        ];;
    }

})(Account);

//Auth
const connectAuth = connect(
    ({ firebase }) => {
        return{
            profile: pathToJS(firebase, 'profile'),
        };
    }
)(fbWrappedComponent);

//Export
export default connect(
    ({ firebase }) => ({
        classrooms: dataToJS(firebase, 'classrooms'),
        schools: dataToJS(firebase, 'schools'),
        customer: dataToJS(firebase, 'customer'),
        products: dataToJS(firebase, 'products'),
        users: dataToJS(firebase, 'users'),
        orders: dataToJS(firebase, 'orders')
    })
)(connectAuth);



// WEBPACK FOOTER //
// ./js/containers/Account/Account.js